import type { CheckpointStatus } from '../api/types.js';
import { escapeAttr, formatBytes, formatDuration } from '../utils.js';

export function renderCheckpointStatus(status: CheckpointStatus): string {
  const bytes = (value: number | null): string => value === null ? 'unknown' : formatBytes(value);
  const duration = (value: number | null): string => value === null ? 'unknown' : `${value} ms`;
  const parts = [
    `Generation ${status.generation}; age ${formatDuration(status.age_sec)}`,
    `${status.pending_layers} layers; pending ${bytes(status.pending_bytes)}; active ${bytes(status.active_bytes)}`,
    status.unsafe ? 'Active cache: unsafe' : 'Active cache: safe',
    `Last durations: sync ${duration(status.sync_duration_ms)}; freeze ${duration(status.freeze_duration_ms)}; commit ${duration(status.commit_duration_ms)}`,
  ];
  if (status.past_max_age) parts.push('Past maximum age');
  if (status.low_space) parts.push(`Low free space: ${bytes(status.free_bytes)} free`);
  if (status.last_error) parts.push(`Last error: ${status.last_error}`);
  return parts.map(escapeAttr).join('<br>');
}

export function checkpointHostAlert(pastMaxAge: number, lowSpace: number): string | null {
  const vms = (count: number): string => `${count} ${count === 1 ? 'VM' : 'VMs'}`;
  const parts = [];
  if (pastMaxAge > 0) parts.push(`${vms(pastMaxAge)} past maximum checkpoint age`);
  if (lowSpace > 0) parts.push(`${vms(lowSpace)} low on space for checkpoint layers`);
  return parts.length ? parts.join('; ') : null;
}
